document.addEventListener("DOMContentLoaded", initCatalog);

function initCatalog() {
  const SELECTS = "select[data-catalog-nav], select[data-catalog-submit]";
  const FOCUS_KEY = "waCatalogFocus";
  const STEP_KEY = /^(Arrow(Up|Down)|Page(Up|Down)|Home|End|[a-z0-9])$/i;
  let pending = null;
  let keyStep = false;

  function commit(select, restoreFocus) {
    if (restoreFocus) {
      try {
        sessionStorage.setItem(FOCUS_KEY, select.id);
      } catch (err) {}
    }
    if (select.hasAttribute("data-catalog-nav")) {
      if (select.value) window.location.href = select.value;
    } else if (select.name === "sort_by" || select.id === "sortSelect") {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      window.location.href = url.toString();
    } else if (select.form) {
      if (typeof select.form.requestSubmit === "function") {
        select.form.requestSubmit();
      } else {
        select.form.submit();
      }
    }
  }

  window.addEventListener("pageshow", function () {
    document.querySelectorAll(SELECTS).forEach(function (select) {
      Array.prototype.forEach.call(select.options, function (option) {
        option.selected = option.defaultSelected;
      });
    });
  });

  document.addEventListener("keydown", function (e) {
    const select = e.target.closest(SELECTS);
    if (!select) return;
    keyStep = STEP_KEY.test(e.key) && !e.altKey && !e.ctrlKey && !e.metaKey;
    if (e.key === "Enter" && pending === select) {
      e.preventDefault();
      pending = null;
      commit(select, true);
    }
  });

  document.addEventListener("keyup", function () {
    keyStep = false;
  });

  document.addEventListener("change", function (e) {
    const select = e.target.closest(SELECTS);
    if (!select) return;
    if (keyStep) {
      pending = select;
      return;
    }
    commit(select, select.matches(":focus-visible"));
  });

  document.addEventListener("focusout", function (e) {
    if (!document.hasFocus()) return;
    if (pending && e.target === pending) {
      const select = pending;
      pending = null;
      commit(select, false);
    }
  });

  let focusId = null;
  try {
    focusId = sessionStorage.getItem(FOCUS_KEY);
    sessionStorage.removeItem(FOCUS_KEY);
  } catch (err) {}
  const target = focusId && document.getElementById(focusId);
  if (target) target.focus({ preventScroll: true });
}
